import React, { useEffect } from "react";
import gameImg from '../../Img/game_img.jpg'
import { MdDoubleArrow } from "react-icons/md";
import { Link } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";
import { FaRocket } from "react-icons/fa";

const AboutHeroSection = () => {


 useEffect(() => {
  import("aos").then((AOS) => {
    AOS.default.init({
      duration: 500,
      once: true,
      offset: 80,
      easing: "ease-out-cubic",
    });
  });
}, []);


  return (
    <section 
      className="relative lg:px-8 text-white sm:py-20 py-10 overflow-hidden bg-gradient-to-br from-gray-900 via-black to-gray-800"
    >
      <div className="container mx-auto px-4">
        
        <div className="flex md:flex-nowrap flex-wrap flex-row-reverse items-center">
          
          <div 
            className="lg:w-3/5 md:w-1/2 w-full"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <div className="md:ps-10 lg:ms-10">
              <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-extrabold leading-tight flex items-center gap-3" data-aos="zoom-in" data-aos-delay="400"
              >
                Our Mission &{" "}
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300">
                  Story
                </span>
              
                <FaRocket className="text-cyan-400 hover:-translate-y-1 transition-transform duration-300" />
              </h2>

              <p 
                className="sm:text-lg text-[16px] text-gray-300 mt-6 leading-relaxed"
                data-aos="fade-up"
                data-aos-delay="600"
              >
                GameZone started with a simple idea: <strong>gaming should be accessible to everyone</strong>. 
                We noticed that finding high-quality, safe, and free browser games was becoming difficult due to annoying ads and slow loading times. We set out to change that.
              </p>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3" data-aos="fade-up" data-aos-delay="750">
                  <div className="flex items-center gap-2 text-gray-300">
                      <IoCheckmarkCircle className="text-green-500" size={20} /> <span>100% Virus Free</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                      <IoCheckmarkCircle className="text-green-500" size={20} /> <span>Play Online Instantly</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                      <IoCheckmarkCircle className="text-green-500" size={20} /> <span>Mobile Optimized</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                      <IoCheckmarkCircle className="text-green-500" size={20} /> <span>Daily New Games</span>
                  </div>
              </div>
   
              <div 
                className="flex mt-4 flex-row gap-4  md:justify-start"
                data-aos="fade-up"
                data-aos-delay="800"
              >
                <Link 
                  to="/games"
                  aria-label="Explore and play free online games"
                  className="px-6 py-3 bg-blue-500 text-white rounded-full font-semibold flex items-center gap-2 hover:bg-blue-600 transition-all duration-300 shadow-lg hover:scale-105"
                >
                  Explore Free Games <MdDoubleArrow size={18} />
                </Link>
              </div>
            </div>
          </div>

          <div 
            className="relative lg:w-2/5 md:w-1/2 w-full md:mt-0 mt-10"
            data-aos="zoom-in-up"
            data-aos-delay="500"
          >
            <div className="rounded-2xl overflow-hidden  shadow-[0_10px_25px_rgba(0,150,255,0.25),0_5px_20px_rgba(255,255,255,0.1)] hover:shadow-[0_15px_35px_rgba(0,150,255,0.35),0_8px_25px_rgba(255,255,255,0.15)] transition-all duration-500 hover:scale-105">
              <picture>
               <source
                  src={gameImg}
                  type="image/jpg"
                />
                <img
                src={gameImg}
                alt="Game Zone Hub Mission - Providing the best free online games instantly"
                className="object-cover w-full h-full cursor-pointer"
                fetchpriority="high"
                decoding="async"
                />
             </picture>
            </div>

            <div className="absolute -z-10 top-10 -left-10 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
            <div className="absolute -z-10 bottom-10 -right-10 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutHeroSection;
